<template>
  <div id="game-wrapper" :class="{start: bStartScreen}" @click="bStartScreen = false" @touchstart.self.prevent="bStartScreen = false">
    <img id="object" src="../src/assets/object.png" alt="" />
    <img id="title" src="../src/assets/title.jpg" alt="" />
    <div id="question">
      <h1 v-html="question.text">
      </h1>
      <ul>
        <li v-for="answer in question.answers" :key="answer.id" :data-answer-id="answer.id" @click="onAnswerClick(answer.id)" @touchstart.self.prevent="onAnswerClick(answer.id)" :class="{current: (answer.id == selectedAnswerId)}">
          <span>{{ answer.text }}</span>
        </li>
      </ul>
    </div>
    <div>
      <div :class="{popup: true, show: (answer.id == selectedAnswerId)}" v-for="answer in question.answers" :key="answer.id" @click="selectedAnswerId = 0" @touchstart.self.prevent="selectedAnswerId = 0" v-html="answer.popup"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Multiple-Choice',
  data () {
    return {
      bStartScreen: true,
      selectedAnswerId: 0,
      question: {
        text: '<span class="small">Heilige sind oft Schutzpatrone für einen bestimmten Ort, Berufsgruppen oder Dinge. Wenn man zu ihnen betet, können sie helfen und beschützen.</span> <br><br><span>Wann kann ich den heiligen Sebastian <br>um etwas bitten?</span>',
        answers: [
          {
            id: 1,
            text: 'Wenn du eine lange Autofahrt vor dir hast und gut ankommen willst.',
            popup: '<h2>Hier kann ich leider nicht helfen</h2> <p><img src="img/sebastian.jpg" >– aber der heilige Christophorus.</p>'
          },
          {
            id: 2,
            text: 'Wenn viele Menschen krank sind und gesund werden möchten.',
            popup: '<h2>Richtig!</h2> <p><img src="img/sebastian.jpg" >Früher, als im Mittelalter viele Menschen an der Pest erkrankt waren, haben sie mich um Hilfe angebetet.</p>'
          },
          {
            id: 3,
            text: 'Wenn es regnet und du dir Sonnenschein wünschst.',
            popup: '<h2>Hier kann ich leider nicht helfen</h2> <p><img src="img/sebastian.jpg" >– aber die heiligen Johannes und Paulus.</p>'
          }
        ]
      }
    }
  },
  methods: {
    onAnswerClick (id) {
      console.log('onAnswerClick()', id)
      this.selectedAnswerId = id
    }
  }
}
</script>
